// src/router/index.js（Vue3 + Vue-CLI 项目）
import { createRouter, createWebHistory } from 'vue-router'
import { MsgBoxBack } from '@/util/msgutil/msgBox'// 引入自定义弹框工具
import Login from '@/views/login/Login.vue'
import Register from '@/views/login/Register.vue'
import FindPwd from '@/views/login/FindPwd.vue'
import Home from '@/views/home/Home.vue'
import IndexHome from '@/views/home/Home_Index.vue' //首页


//子页面
// import UserManagement from '../views/system/UserManagement.vue'

const routes = [
    {
        path: '/',
        redirect: '/login', // 根路径默认跳转到登录页
        meta: { noToken: true }//不校验token标识
    },
    {
        path: '/login',
        name: 'Login',
        component: Login, // 登录页（无需token）
        meta: { noToken: true }
    },
    {
        path: '/register',
        name: 'Register',
        component: Register, // 注册页（无需token）
        meta: { noToken: true }
    },
    {
        path: '/findPwd',
        name: 'FindPwd',
        component: FindPwd, // 找回密码页（无需token）
        meta: { noToken: true }
    },
    {
        path: '/home',
        name: 'Home',
        component: Home, // 登录后首页
        children: [
            { path: '', component: IndexHome  },//没有路径时 默认主页
            { path: '/home/indexHome', component: IndexHome },//内部显示的主页
            // 系统管理子页面
            { path: '/home/editmenu/EditMenu',  component: () => import('@/views/home/editmenu/EditMenu.vue')},//菜单管理
            { path: '/home/role/RoleList',  component: () => import('@/views/home/role/RoleList.vue')},//角色管理
            { path: '/home/user/UserList',  component: () => import('@/views/home/user/UserList.vue')},//用户管理
            { path: '/home/enumitem/EnumList',  component: () => import('@/views/home/enumitem/EnumList.vue')},//枚举管理
            { path: '/home/company/CompanyList',  component: () => import('@/views/home/company/CompanyList.vue')},//枚举管理
            //业务板块
            //收支
            // { path: '/job/dataAnalysis/',  component: () => import('@/views/job/dataAnalysis/DataAnalysis.vue')},//数据分析页面
            { path: '/job/cstMgtList/',  component: () => import('@/views/job/cstMgt/cstMgtList.vue')},//客户管理
            { path: '/job/area/',  component: () => import('@/views/job/area/areaList.vue')},//地址管理
            { path: '/job/preset/',  component: () => import('@/views/job/preset/PresetIndex.vue')},//废品信息预设
            { path: '/job/vehicleAudit/',  component: () => import('@/views/job/vehicleAudit/vehicleAuditList.vue')},//车辆审核列表
            { path: '/job/vehicleAuditDetail/',  component: () => import('@/views/job/vehicleAudit/vehicleAuditDetail.vue')},//车辆审核详情
            { path: '/job/insurance/',  component: () => import('@/views/job/insurance/insuranceList.vue')},//车辆保险管理
            { path: '/job/checkHandle/',  component: () => import('@/views/job/checkHandle/checkHandleList.vue')},//年检办理
            { path: '/job/holiday/',  component: () => import('@/views/job/holiday/HolidayList.vue')},//假期设置
            { path: '/job/exchangeItem/',  component: () => import('@/views/job/exchange/ExchangeItemList.vue')},//积分兑换物品
            { path: '/job/exchangeRecord/',  component: () => import('@/views/job/exchange/ExchangeRecordList.vue')},//积分兑换记录
            { path: '/job/verifyRecord/',  component: () => import('@/views/job/exchange/VerifyRecordList.vue')},//我的核验记录
            { path: '/job/welfareActivity/',  component: () => import('@/views/job/welfare/WelfareActivityList.vue')},//福利活动管理
            //收租
            // { path: '/job/rentContract/',  component: () => import('@/views/job/rent/rentContractList.vue')},//租房合同管理
            // { path: '/job/rentRecord/',  component: () => import('@/views/job/rent/rentRecordList.vue')}//收租记录管理
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// 路由守卫：控制页面访问权限
router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem('token') // 获取本地存储的token
    const noToken1 = to.meta.noToken
    // 规则：非指定不校验token页面 且无token → 跳转到登录页
    if ( !noToken1 && !token) {
        MsgBoxBack.warning('登录已过期，请重新登录', () => {
            next('/login')
        });
    } else {
        //打开默认页（非点击菜单切换） 当 角色还没加载出来时 等待一秒后重试，重试3次任失败 返回登录页
        if(to.path == "/home"){
            next(`/home/indexHome`)
        }else{
            next()
        }
    }
})

export default router